@if (loaded()) {
  <div id="hunt-details-page-wrapper">
    <!-- Header Section -->
    <div class="page-header">
      <div class="left">
        <hyperkit-breadcrumb-list
          class="breadcrumb-list"
          [items]="breadcrumbs()"
        ></hyperkit-breadcrumb-list>
        <div>
          <hyperkit-typography variant="h2" display="inline">
            {{ huntView.name() }}
          </hyperkit-typography>
          @if (huntView.totalHuntQueries() > 0) {
            <hyperkit-segmented-progress-bar
              [segments]="huntView.huntProgressSegments()"
              [showLabels]="true"
              size="small"
            ></hyperkit-segmented-progress-bar>
          }
        </div>
        <div class="meta-data-tags">
          <!-- Priority Badge -->
          <hyperkit-badge
            [variant]="huntView.priorityVariant()"
            size="base"
            indicator="none"
            [text]="huntView.priority()"
          ></hyperkit-badge>
          <!-- Status Badge -->
          <hyperkit-badge
            [variant]="huntView.statusVariant()"
            size="base"
            indicator="none"
            textLeft="Status"
            [text]="huntView.status()"
          ></hyperkit-badge>
          <!-- Outcome Badge -->
          @if (huntView.outcome()) {
            <hyperkit-badge
              [variant]="huntView.outcomeVariant()"
              size="base"
              indicator="none"
              textLeft="Outcome"
              [text]="huntView.outcome()"
            ></hyperkit-badge>
          }
          <!-- Created & Last Modified Tags -->
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Created"
            [text]="huntView.createdDate()"
          ></hyperkit-tag>
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Last Modified"
            [text]="huntView.lastModified()"
          ></hyperkit-tag>
          <!-- Author & Assignee Tags -->
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Author"
            [text]="huntView.authorFullName()"
          ></hyperkit-tag>
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Assignee"
            [text]="huntView.assigneeFullName()"
          ></hyperkit-tag>
          <!-- Template Link Tag -->
          @if (huntView.hasHuntTemplate()) {
            <hyperkit-tag
              [routerLink]="['/hunt/hunt-template', huntView.huntTemplateId()]"
              icon="link-2"
              mode="fill"
              [closable]="false"
              textLeft="Template"
              [text]="huntView.huntTemplateName()"
            ></hyperkit-tag>
          }
        </div>
      </div>
      <!-- Action Buttons -->
      <div class="right">
        @if (error) {
          <hyperkit-error [error]="error"></hyperkit-error>
        }
        <hyperkit-button
          variant="standard"
          color="secondary"
          size="small"
          icon="arrow-left"
          iconPosition="left"
          text="Back to Hunt"
          (click)="backToHunt()"
        ></hyperkit-button>
        <hyperkit-button
          variant="standard"
          color="secondary"
          size="small"
          text="Done"
          (click)="done()"
        ></hyperkit-button>
        <hyperkit-button-menu
          variant="icon"
          color="secondary"
          size="medium"
          icon="menu"
          (itemSelected)="handleMenuAction($event)"
        >
          <hyperkit-dropdown-menu-item
            value="update"
            label="Update Hunt Details"
          ></hyperkit-dropdown-menu-item>
          <hyperkit-dropdown-menu-item
            value="archive"
            label="Archive"
          ></hyperkit-dropdown-menu-item>
        </hyperkit-button-menu>
      </div>
    </div>
    <!-- Main Content: Section Nav + Details + Notes -->
    <div class="page-content">
      <!-- Sidebar navigation -->
      <div id="report">
        <div id="report-header">
          <div id="report-title">
            <hyperkit-typography variant="h5">
              Threat Hunt Report
            </hyperkit-typography>
          </div>
          <div id="report-list">
            <div class="report-container">
              @for (section of reportSections(); track section) {
                <hyperkit-report-section
                  [section]="section"
                  [selectedSectionId]="selectedSectionId()"
                  (selectSection)="onSelectSection($event)"
                ></hyperkit-report-section>
              }
            </div>
          </div>
        </div>
      </div>
      <!-- Dynamic section content -->
      <div id="report-details">
        <router-outlet></router-outlet>
      </div>
      <!-- Always-visible Notes editor -->
      <div id="hunt-notes">
        <hunt-details-editor
          title="Notes"
          height="calc(100vh - 170px)"
          [value]="huntView.notes()"
          (valueChange)="huntEditor.updateNotes($event)"
        ></hunt-details-editor>
      </div>
    </div>
  </div>
} @else {
  <p>Loading…</p>
}
